import React from 'react';
import { CustomCardGrid } from './../../../../../components/CustomCardGrid';
import RowCardText from './../../../../../components/RowCardText';
import { statusBorderColor, statusColor, statusFontColor } from '../../../../../enums/statusColorEnum';
import CustomChip from '../../../../../components/CustomChip';
import { currencyFormat, EMPTY_VALUES } from '../../../../../Apis/functions';
import {
    EmailSubsectionChip,
    IconMarkerTable,
    IconMoneyRemain,
    IconMoneyTotal,
    PhoneSubsectionChip,
} from '../../../../../components/buttons/IconButtons';
import userDefault from '../../../../../assets/ImagesDefaults/ic-person-v2.svg';
import { userType } from '../../../../../enums/userTypeEnum';
import {status, STATUS_MODEL} from '../../../../../enums/statusEnum';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {colors} from '../../../../../enums/colors';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const UserDetailsCard = ({ t, data }) => {


    const getChipStyle = (statusId, t) => {
        if (!statusId) {
            return {
                background: colors.secondary100,
                fontColor: colors.secondary700,
                borderColor: colors.secondary150,
                legend: t("normal")
            };
        }

        if (statusId === STATUS_MODEL.ISSUED) {
            return {
                background: colors.errorCode100,
                fontColor: colors.errorCode700,
                borderColor: colors.errorCode150,
                legend: t("fined")
            };
        }

        return {
            background: statusColor[statusId],
            fontColor: statusFontColor[statusId],
            borderColor: statusBorderColor[statusId],
            legend: t(status[statusId])
        };
    };

    const chip = getChipStyle(data?.statusIdChecked, t);
    return (
        <CustomCardGrid
            classNamePanelGrid=''
            height='border-full-shades-200'
            itemId={data?.id}
            statusColor={chip?.background}
            fontColor={chip?.fontColor}
            borderColor={chip?.borderColor}
            statusName={chip?.legend || EMPTY_VALUES.DEFAULT}
            chipVariant={'large'}
            isSquareImg={false}
            isCheckboxShow={false}
            headClass={'minh-144px'}
            srcImage={data?.selfie ? `data:image/png;base64,${data?.selfie}` : userDefault}
            backgroundImage={data?.selfie != null ? `data:image/png;base64,${data?.selfie}` : ''}
        >
            <div className='d-flex flex-column align-items-center mb-4'>
                <p className='ibl-h3 ibl-font-w-600 text-capitalize'>{data?.fullName}</p>
                <CustomChip
                    background={statusColor[STATUS_MODEL.IN_PROGRESS]}
                    fontColor={statusFontColor[STATUS_MODEL.DELIVERED]}
                    borderColor={statusBorderColor[STATUS_MODEL.TO_APPROVE_DOCUMENT]}
                    legend={t(userType[data?.userTypeId])}
                    variant={'compact'}
                />
            </div>
            <div className='border-bottom-shades-300 mb-3 ' />
            <div className='d-flex align-items-center my-2'>
                <IconMoneyRemain />
                <RowCardText
                    className='my-3 ml-3'
                    title={t('pending_fines')}
                    value={data?.finePending || EMPTY_VALUES.DEFAULT}
                />
            </div>
            <div className='d-flex align-items-center my-2'>
                <IconMoneyTotal />
                <RowCardText className='ml-3' title={t('total_paid')} value={'$ ' + currencyFormat(data?.totalPaid)} />
            </div>
            <div className='d-flex align-items-center my-2'>
                <IconMarkerTable />
                <RowCardText
                    className='my-3 ml-3'
                    title={t('frequent_infraction_geofence')}
                    value={
                        <CustomTooltip
                            text={data?.frequentGeofence || EMPTY_VALUES.DEFAULT}
                            showIfTruncated={false}
                            placement='bottom'
                        >
                            <span>{data?.frequentGeofence || EMPTY_VALUES.DEFAULT}</span>
                        </CustomTooltip>
                    }
                />
            </div>
            <div className='border-bottom-shades-300 mt-3 mb-3 ' />
            <div className='d-flex align-items-center my-2'>
                <EmailSubsectionChip />
                <RowCardText
                    className='my-3 ml-3'
                    title={t('email')}
                    value={
                        <CustomTooltip
                            text={data?.email || EMPTY_VALUES.DEFAULT}
                            showIfTruncated={false}
                            placement='bottom'
                        >
                            <span>{data?.email || EMPTY_VALUES.DEFAULT}</span>
                        </CustomTooltip>
                    }
                />
            </div>
            <div className='d-flex align-items-center my-2'>
                <PhoneSubsectionChip />
                <RowCardText
                    className='ml-3'
                    title={t('telephone')}
                    value={data?.phoneNumber || EMPTY_VALUES.DEFAULT}
                />
            </div>
        </CustomCardGrid>
    );
};

export default UserDetailsCard;
